import { render, staticRenderFns } from "./Transferencia.vue?vue&type=template&id=0a0f6ebf&"
import script from "./Transferencia.vue?vue&type=script&lang=js&"
export * from "./Transferencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports